<template>
    <div class="content">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         src="@/assets/theme/light/status/01dailyActive/01back.svg">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('trainCalendar.title') }}</div>
                    </van-col>
                    <van-col span="6" @click="toPlanLibrary"><img class="back-icon right-icon"
                                           src="@/assets/theme/light/trainPlan/06planDesc/01more.svg">
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-select">
                    <img @click="timeLeft" class="time-icon"
                         src="@/assets/theme/light/status/01dailyActive/03left.svg">
                    <div class="time-date">{{ time }}</div>
                    <img @click="timeRight" class="time-icon"
                         src="@/assets/theme/light/status/01dailyActive/04right.svg">
                </div>
            </div>
            <div class="week-title">
                <div class="week-item">{{ $t('setPlanDate.repeatText0') }}</div>
                <div class="week-item">{{ $t('setPlanDate.repeatText1') }}</div>
                <div class="week-item">{{ $t('setPlanDate.repeatText2') }}</div>
                <div class="week-item">{{ $t('setPlanDate.repeatText3') }}</div>
                <div class="week-item">{{ $t('setPlanDate.repeatText4') }}</div>
                <div class="week-item">{{ $t('setPlanDate.repeatText5') }}</div>
                <div class="week-item">{{ $t('setPlanDate.repeatText6') }}</div>
            </div>
            <div class="month-row" v-for="(week, k) in weekData" :key="k">
                <div class="day-box" v-for="(item, i) in week" :key="i" @click="toDetail(item)">
                    <div class="month-col-item">
                        <div class="item-chart-box">
                            <van-circle v-if="item.groupCount && item.date <= today" class="item-circle"
                                        :value="item.finishedGroupCount/item.groupCount*100" color="var(--chart-color-1)"
                                        :stroke-width="100" size="40px"/>
                            <div class="day" :class="{'light-day':item.isOut === 1}"><span
                                :class="{'green':item.isToday}">{{ item.day }}</span>
                            </div>
                        </div>
                        <div class="bottom-box">
                            <div v-if="item.groupCount">
                                <div class="finished-show" v-if="item.totalCapacity">{{ item.totalCapacity }}</div>
                                <div class="finished-show" v-else-if="item.actTime">{{
                                        SwitchTime24(item.actTime)
                                    }}
                                </div>
                            </div>
                            <div class="finished-show train-part" v-for="part in item.trainParts">{{ part }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <van-dialog
            :closeOnClickOverlay="true"
            v-model="showDetail"
            :showConfirmButton="false"
        >
            <div class="detail-box">
                <div class="page-box">
                    <img class="page-icon" :class="{'page-icon-ban':current===1}"
                         @click="changePage(-1)"
                         src="@/assets/theme/light/trainPlan/08trainCalendar/01left.svg">
                    <div class="page-num">{{ current }}/{{ total }}</div>
                    <img class="page-icon" @click="changePage(1)" :class="{'page-icon-ban':current===total}"
                         src="@/assets/theme/light/trainPlan/08trainCalendar/02right.svg">
                </div>
                <div class="detail-content">
                    <div class="detail-top">
                        <div class="detail-sub">
                            <div class="detail-title">{{ planInfo.planName }}</div>
                            <div class="detail-to-see" v-if="planInfo.sportId" @click="toSportDesc(planInfo.sportId)">
                                {{ $t('trainCalendar.seeDetail') }}
                            </div>
                            <div class="detail-to-start" v-if="showStartPlan&&!planInfo.sportId"
                                 @click="toStartSport(planInfo.userPlanId)">{{ $t('planDesc.start') }}
                            </div>
                        </div>
                        <div class="detail-sub" v-if="planInfo.sportId">
                            <div class="detail-left">
                                <div class="detail-capacity" v-if="planInfo.totalCapacity">{{ planInfo.totalCapacity }}
                                    {{ $t('startTrain.capacity') }}
                                </div>
                                <div class="detail-duration">{{ SwitchTime24(planInfo.actTime) }}</div>
                            </div>
                            <div class="detail-time">{{ planInfo.startSportTime }}</div>
                        </div>
                    </div>
                    <div class="detail-group-box">
                        <div class="group-item" v-for="(item, i) in actionList">
                            <div class="action-title-box">
                                <img class="action-icon" :src="item.bannerUrl">
                                <div class="action-name" v-if="$i18n.locale === 'en'">{{ item.actionNameEn }}</div>
                                <div class="action-name" v-else-if="$i18n.locale === 'ja'">{{ item.actionNameJa }}</div>
                                <div class="action-name" v-else>{{ item.actionName }}</div>
                                <div class="top-capacity" v-if="item.totalCapacity">{{ item.totalCapacity }}
                                    {{ item.unit }}
                                </div>
                            </div>
                            <div class="group-box" :class="{'incomplete': !group.t || !planInfo.sportId}"
                                 v-for="(group, j) in item.actionList" :key="j">
                                <div class="item-bg">
                                    <div class="group-index">{{ j + 1 }}</div>
                                    <div class="record-type" v-if="item.recordType == 1">
                                        {{ group.w }} {{ item.unit }} × {{ group.f }}
                                    </div>
                                    <div class="record-type" v-if="item.recordType == 2">
                                        {{ SwitchTime24(group.t) }}
                                    </div>
                                    <div class="record-type" v-if="item.recordType == 3">
                                        {{ group.f }} {{ $t('planEdit.frequency') }}
                                    </div>
                                    <div class="record-type" v-if="item.recordType == 4">
                                        {{ group.d }} km
                                    </div>
                                </div>
                                <div class="action-time" v-if="group.rt">{{
                                        SwitchTime24hms(group.rt)
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import {
    changeMonthDate,
    GetDateStr,
    getMonthEndDay,
    getMonthStartDay,
    getNWeekFirstDay,
    getNWeekLastDay, getStr, GetYear,
    SwitchTime24,
    SwitchTime24hms
} from "../../utils/dateUtils";
import {getSportTrainByDate, getSportTrainById, getUserTrainPlanById} from "../../api/trainPlan";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'trainCalendar',
    data() {
        return {
            time: '',
            startDate: '',
            endDate: '',
            mNum: 0,
            monthData: [],
            afterTrainParts: [],
            thisMonthEnd: '',
            weekData: [],
            today: '',
            showDetail: false,
            current: 1,
            total: 1,
            actionList: [],
            planInfo: {},
            detailIds: [],
            showStartPlan: false,
            theme: 'light'
        }
    },
    mounted() {
        this.startDate = getMonthStartDay(this.mNum);
        this.endDate = getMonthEndDay(this.mNum);
        this.time = changeMonthDate(this.startDate);
        this.thisMonthEnd = getMonthEndDay(0);
        this.today = getStr(new Date())
        this.createCalendar();
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        timeLeft() {
            this.mNum--;
            this.startDate = getMonthStartDay(this.mNum);
            this.endDate = getMonthEndDay(this.mNum);
            this.time = changeMonthDate(this.startDate);
            this.createCalendar();
        },
        timeRight() {
            this.mNum++;
            this.startDate = getMonthStartDay(this.mNum);
            this.endDate = getMonthEndDay(this.mNum);
            this.time = changeMonthDate(this.startDate);
            this.createCalendar();
        },
        createCalendar() {
            let monthStartDate = getMonthStartDay(this.mNum);
            this.month = monthStartDate.replace(/[-]/g, "/").slice(0, 7);
            let now = new Date(monthStartDate);
            let d = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            let days = d.getDate();
            let weekNum = new Date(monthStartDate).getDay();
            this.monthData = [];

            // 计算上个月的最后一天
            let lastMonthEndDate = new Date(now.getFullYear(), now.getMonth(), 0);
            let lastMonthDays = lastMonthEndDate.getDate();
            let lastMonthWeekNum = lastMonthEndDate.getDay();

            if (weekNum != 1) {
                if (weekNum == 0) weekNum = 7;
                // 添加上个月的最后一周日期
                for (let i = lastMonthDays - lastMonthWeekNum + 1; i <= lastMonthDays; i++) {
                    let date = getStr(new Date(lastMonthEndDate.getFullYear(), lastMonthEndDate.getMonth(), i));
                    this.monthData.push({
                        day: i,
                        isOut: 1,
                        totalCapacity: 0,
                        actTime: 0,
                        groupCount: 0,
                        finishedGroupCount: 0,
                        trainParts: [],
                        date: date,
                        sportId: [],
                        userPlanId: []
                    })
                }
            }


            for (let i = 1; i <= days; i++) {
                let date = getStr(new Date(now.getFullYear(), now.getMonth(), i));
                this.monthData.push({
                    day: i,
                    isOut: 0,
                    isToday: date === this.today,
                    totalCapacity: 0,
                    actTime: 0,
                    groupCount: 0,
                    finishedGroupCount: 0,
                    trainParts: [],
                    date: date,
                    sportId: [],
                    userPlanId: []
                })
            }

            // 计算下个月的第一天
            let nextMonthStartDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);
            let nextMonthDays = new Date(now.getFullYear(), now.getMonth() + 2, 0).getDate();
            let nextCount = this.monthData.length % 7;
            for (let i = 1; i <= 7 - nextCount; i++) {
                let date = getStr(new Date(nextMonthStartDate.getFullYear(), nextMonthStartDate.getMonth(), i));
                this.monthData.push({
                    day: i,
                    isOut: 1,
                    trainParts: [],
                    date: date,
                    sportId: [],
                    userPlanId: []
                });
            }
            this.getCalendarUserTrainPlan();
            this.getSportTrainByDate();
        },
        getCalendarUserTrainPlan() {
            this.$api.trainPlan.getCalendarUserTrainPlan({
                startDate: this.monthData[0].date,
                endDate: this.monthData[this.monthData.length - 1].date,
            }).then(res => {
                this.afterTrainParts = res.info;
                this.dealAfterTrainParts();
            })
        },
        getRepeatDate(repeat, startDate, endDate) {
            startDate = new Date(startDate)
            endDate = new Date(endDate)
            let result = [];
            // 遍历日期范围
            while (startDate <= endDate) {
                let dayOfWeek = (startDate.getDay() + 6) % 7; // 调整星期几的表示方式
                if (repeat.includes(dayOfWeek)) {
                    result.push(getStr(new Date(startDate))); // 将符合条件的日期加入结果数组
                }
                startDate.setDate(startDate.getDate() + 1); // 增加一天
            }
            return result;
        },
        dealAfterTrainParts() {
            for (let i = 0; i < this.afterTrainParts.length; i++) {
                let repeatDate = this.getRepeatDate(this.afterTrainParts[i].weeklyRepeat, this.afterTrainParts[i].startDate, this.afterTrainParts[i].endDate);
                let trainPart = this.afterTrainParts[i].trainParts.split(',');
                let trainPartText = [];
                for (let j = 1; j <= trainPart.length; j++) {
                    trainPartText.push(this.$t('actionLibrary.action' + j))
                }
                for (let j = 0; j < repeatDate.length; j++) {
                    for (let k = 0; k < this.monthData.length; k++) {
                        if (this.monthData[k].date === repeatDate[j]) {
                            this.monthData[k].trainParts = Array.from(new Set(this.monthData[k].trainParts.concat(trainPartText)));
                            this.monthData[k].userPlanId.push(this.afterTrainParts[i].userPlanId)
                            this.monthData[k].userPlanId = [...new Set(this.monthData[k].userPlanId)];
                            this.monthData[k].groupCount = this.monthData[k].groupCount + this.afterTrainParts[i].groupCount;
                        }
                    }
                }

            }
            this.dealWeekData()
        },
        dealWeekData() {
            this.weekData = [];
            for (let i = 0; i < this.monthData.length; i += 7) {
                this.weekData.push(this.monthData.slice(i, i + 7));
            }
        },
        getSportTrainByDate() {
            this.$api.trainPlan.getSportTrainByDate({
                startDate: this.monthData[0].date,
                endDate: this.monthData[this.monthData.length - 1].date,
            }).then(res => {
                this.dealSportData(res.info)
            })
        },
        dealSportData(orgData) {
            for (let i = 0; i < orgData.length; i++) {
                let trainPart = orgData[i].trainParts.split(',');
                let trainPartText = [];
                for (let j = 1; j <= trainPart.length; j++) {
                    trainPartText.push(this.$t('actionLibrary.action' + j))
                }
                let date = getStr(new Date(orgData[i].startSportTime))
                for (let k = 0; k < this.monthData.length; k++) {
                    if (this.monthData[k].date === date) {
                        this.monthData[k].sportId.push({
                            sportId: orgData[i].sportId,
                            userPlanId: orgData[i].userPlanId
                        })
                        this.monthData[k].sportId = [...new Set(this.monthData[k].sportId)];
                        this.monthData[k].trainParts = Array.from(new Set(this.monthData[k].trainParts.concat(trainPartText)));
                        this.monthData[k].totalCapacity = this.monthData[k].totalCapacity + orgData[i].totalCapacity;
                        this.monthData[k].actTime = this.monthData[k].actTime + orgData[i].actTime;
                        this.monthData[k].finishedGroupCount = this.monthData[k].finishedGroupCount + orgData[i].finishedGroupCount;
                    }
                }

            }
        },
        SwitchTime24(n) {
            return SwitchTime24(n)
        },
        toDetail(item) {
            if (this.today === item.date) {
                this.showStartPlan = true
            } else {
                this.showStartPlan = false
            }
            this.current = 1;
            this.detailIds = []
            for (let i = 0; i < item.userPlanId.length; i++) {
                let tag = 0;
                for (let j = 0; j < item.sportId.length; j++) {
                    if (item.sportId[j].userPlanId === item.userPlanId[i]) {
                        this.detailIds.push({id: item.sportId[j].sportId, type: 'sport'})
                        tag = 1;
                    }
                }
                if (tag === 0) {
                    this.detailIds.push({id: item.userPlanId[i], type: 'plan'})
                }
            }
            if (item.userPlanId.length === 0 && item.sportId.length !== 0) {
                for (let j = 0; j < item.sportId.length; j++) {
                    this.detailIds.push({id: item.sportId[j].sportId, type: 'sport'})
                }
            }
            this.total = this.detailIds.length;
            if (this.total > 0) {
                this.getDetailById(0)
                this.showDetail = true;
            }
        },
        SwitchTime24hms(n) {
            return SwitchTime24hms(n)
        },
        getDetailById(index) {
            let item = this.detailIds[index]
            if (item.type == 'sport') {
                this.$api.trainPlan.getSportTrainById({
                    sportId: item.id
                }).then(res => {
                    this.planInfo = res.info;
                    this.actionList = res.info.actionList;
                    this.initActionList(this.planInfo);
                })
            } else {
                this.$api.trainPlan.getUserTrainPlanById({
                    userPlanId: item.id
                }).then(res => {
                    this.planInfo = res.info;
                    this.actionList = res.info.actionList;
                    this.initActionList(this.planInfo);
                })
            }
        },
        changePage(num) {
            let target = this.current + num;
            if (target > 0 && target <= this.total) {
                this.current = target;
                this.getDetailById(this.current - 1)
            }
        },
        initActionList(obj) {
            let actionListGroup = JSON.parse(obj.actionListGroup)
            let actionListUnit = [];
            if (obj.actionListUnit) {
                actionListUnit = obj.actionListUnit.split(',')
            }
            let index = 0;
            // 将 actionId 字符串解析为数组
            const actionIdArray = obj.actionListId.split(',').map(Number);

            // 根据 actionIdArray 的顺序对 actionList 进行排序
            this.actionList.sort((a, b) => {
                return actionIdArray.indexOf(a.actionId) - actionIdArray.indexOf(b.actionId);
            });
            for (let i = 0; i < this.actionList.length; i++) {
                this.actionList[i].currentIndex = 0
                this.actionList[i].currentCapacity = 0
                this.actionList[i].currentf = 0
                this.actionList[i].currentd = 0
                this.actionList[i].f = 0
                this.actionList[i].d = 0
                this.actionList[i].capacity = 0
                this.actionList[i].actionList = actionListGroup[i]
                if (actionListUnit.length > 0) {
                    this.actionList[i].unit = actionListUnit[i]
                }
                for (let j = 0; j < this.actionList[i].actionList.length; j++) {
                    this.actionList[i].actionList[j].index = index;
                    index++;
                    if (this.actionList[i].recordType === 3) {
                        this.actionList[i].f = this.actionList[i].f + parseInt(this.actionList[i].actionList[j].f);
                    }
                    if (this.actionList[i].recordType === 4) {
                        this.actionList[i].d = this.actionList[i].d + parseInt(this.actionList[i].actionList[j].d);
                    }
                    if (this.actionList[i].recordType === 1) {
                        this.actionList[i].capacity = this.actionList[i].capacity + parseInt(this.actionList[i].actionList[j].w) * parseInt(this.actionList[i].actionList[j].f);
                    }
                }
            }
        },
        toSportDesc(id) {
            this.$router.push({
                name: 'sportTrainDesc',
                query: {
                    sportId: id,
                    lang: this.$i18n.locale,
                    from: 'web',
                    parent: 'trainCalendar',
                    theme: this.theme
                }
            })
        },
        toStartSport(id) {
            this.$router.push({
                name: 'startTrain',
                query: {
                    userPlanId: id,
                    lang: this.$i18n.locale,
                    from: 'web',
                    theme: this.theme
                }
            })
        },
        toPlanLibrary() {
            this.$router.push({
                name: 'planLibrary',
                query: {
                    lang: this.$i18n.locale,
                    from: 'web',
                    theme: this.theme
                }
            })
        }
    }
}
</script>

<style scoped>

.content {
    width: 100%;
    color: var(--text-color-1);
    position: relative;
    background-color: var(--bg-color-2);
    padding-bottom: 5px;
}

.right-icon {
    float: right;
}


.time-select {
    text-align: center;
    padding-top: 12px;
    position: relative;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.time-icon {
    width: 7px;
}

.time-date {
    display: inline-block;
    width: 201px;
    font-size: 15px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    color: var(--text-color-1);
}

.time-box {
    padding-top: 98px;
    height: 44px;
}

.banner {
    background-color: var(--bg-color-2);
}

.week-title {
    text-align: center;
    display: flex;
    justify-content: center;
    width: 360px;
    margin: 0 auto;
}

.week-item {
    display: inline-block;
    width: 51px;
    height: 33px;
    line-height: 33px;
    color: var(--text-color-2);
    font-size: 13px;
}

.month-row {
    width: 360px;
    height: 116px;
    background: var(--bg-color-1);
    border-radius: 8px 8px 8px 8px;
    display: flex;
    justify-content: center;
    margin: 0 auto 5px;
}

.day-box {
    width: 51px;
    text-align: center;
    height: 116px;
}

.day {
    font-size: 15px;
    font-weight: 500;
    line-height: 40px;
    font-family: PP;
}

.light-day {
    color: var(--text-color-3);
}

.item-chart-box {
    width: 40px;
    height: 40px;
    margin: 6px auto 0;
    position: relative;
}

.item-circle {
    position: absolute;
    left: 0;
    top: 0;
}

.green {
    color: var(--chart-color-1);
}

.finished-show {
    width: 48px;
    height: 16px;
    background: #DAEDE5;
    border-radius: 4px 4px 4px 4px;
    color: var(--chart-color-1);
    text-align: center;
    line-height: 16px;
    font-size: 10px;
    margin: 4px auto;
    overflow: hidden; /* 隐藏溢出的内容 */
    white-space: nowrap; /* 防止文字换行 */
    text-overflow: ellipsis;
}

.train-part {
    background: #7A82A2;
    color: var(--bg-color-2);
}

.bottom-box {
    height: 66px;
    overflow-y: scroll;
}

.page-box {
    padding-top: 13px;
    display: flex;
    justify-content: center;
}

.page-icon {
    width: 22px;
}

.page-num {
    margin: 0 20px;
    font-weight: 500;
    font-size: 19px;
    color: var(--text-color-1);
    display: inline-block;
    font-family: PP;
}

.page-icon-ban {
    opacity: 0.2;
}

.detail-top {
    border-bottom: 1px solid var(--bg-color-1);
    padding-bottom: 14px;
}

.detail-title {
    font-size: 19px;
    color: var(--text-color-1);
    float: left;
}

.detail-to-see {
    font-size: 13px;
    color: var(--chart-color-1);
    float: right;
}

.detail-sub {
    font-size: 13px;
    color: var(--text-color-1);
    display: flex;
    justify-content: space-between;
}

.detail-time {
    color: var(--text-color-2);
    float: right;
}

.detail-box {
    padding: 0 18px;
}

.detail-sub {
    width: 100%;
    margin-top: 4px;
}

.detail-left {
    width: 50%;
}

.detail-left div {
    display: inline-block;
}

.detail-capacity {
    margin-right: 15px;
}


.action-box {
    width: 345px;
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto 10px;
    background: var(--bg-color-2);
}

.action-title-box {
    height: 55px;
    position: relative;
}

.action-icon {
    width: 46px;
    position: absolute;
    top: 16px;
    left: 15px;
}

.action-name {
    font-weight: 400;
    font-size: 17px;
    color: var(--text-color-1);
    position: absolute;
    left: 71px;
    top: 18px;
    width: 213px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* 设置行数 */
    -webkit-box-orient: vertical;
}

.top-capacity {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    left: 71px;
    top: 43px;
}

.group-box {
    width: calc(100% - 60px);
    margin-left: 60px;
    font-size: 13px;
    color: var(--text-color-1);
    font-family: PP;
    height: 33px;
    margin-bottom: 10px;
}

.group-index {
    width: 20px;
    text-align: center;
    display: inline-block;
}

.record-type {
    display: inline-block;
    width: 100px;
    margin-left: 10px;
}

.action-time {
    color: var(--text-color-2);
    display: inline-block;
}

.incomplete {
    color: var(--text-color-3);
}

.fixed-top {
    height: 88px;
    width: 100%;
    background-color: var(--bg-color-2);
    position: fixed;
    top: 0px;
    z-index: 111;
}

.detail-group-box {
    max-height: 345px;
    overflow-y: scroll;
}

.item-bg {
    width: 134px;
    background: var(--bg-color-1);
    border-radius: 7px 7px 7px 7px;
    display: inline-block;
    padding: 8px 12px;
    margin-right: 15px;
}

.detail-to-start {
    background: var(--bg-color-1);
    border-radius: 6px 6px 6px 6px;
    padding: 0 10px;
    font-size: 13px;
    color: var(--text-color-1);
    height: 25px;
    line-height: 25px;
}
</style>


// WEBPACK FOOTER //
// src/views/trainPlan/08trainCalendar.vue